<template>
  <div>
    <modal
      name="modal-optimized-pos-googlemap"
      :width="`90%`"
      :height="`auto`"
      scrollable
      @opened="onModalOpened"
      :clickToClose="false"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <div ref="pos_google_map" class="pos_google_map"></div>
            </v-col>
          </v-row>
          <v-row v-if="!optimizedPos">
            <v-col cols="12" sm="12" md="12">
              <h5>There is no data to display !</h5>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.stop="hideModal()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";

export default {
  name: "DialogOptimizedPOS",
  components: {},
  data: function() {
    return {
      worksessionId: null,
      optimizedPos: null,
      sharedLink: null,
       startPosition: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    async showModal(worksessionId, optimizedPos,startPosition) {
      this.startPosition = startPosition;  
      await this.init(worksessionId, optimizedPos);
      this.$modal.show("modal-optimized-pos-googlemap");
    },
    hideModal() {
      this.$modal.hide("modal-optimized-pos-googlemap");
    },
    onModalOpened() {
      this.initMap();
    },
    initMap() {
    const directionsService = new window.google.maps.DirectionsService();
    const directionsRenderer = new window.google.maps.DirectionsRenderer();
    
    const startLat = this.startPosition?.latitude;
    const startLng = this.startPosition?.longitude;
  
    var mapOptions = {
      zoom: 12,
      center: new window.google.maps.LatLng(startLat, startLng) 
    };
    
    var map = new window.google.maps.Map(
      this.$refs.pos_google_map,
      mapOptions
    );
    
    directionsRenderer.setMap(map);
    
    if (this.optimizedPos.length > 0) {
      console.log("Creating route with", this.optimizedPos.length, "POS");
      
      let startPoint = new window.google.maps.LatLng(startLat, startLng)
      let endPoint = new window.google.maps.LatLng(
        this.optimizedPos[this.optimizedPos.length - 1].lat,
        this.optimizedPos[this.optimizedPos.length - 1].lng
      );
      
      let waypoints = [];
      for (let i = 0; i < this.optimizedPos.length; i++) {
        let posItem = this.optimizedPos[i];
        let posItemPoint = new window.google.maps.LatLng(
          posItem.lat,
          posItem.lng
        );
        waypoints.push({ 
          location: posItemPoint,
          stopover: true 
        });
      }
          
      this.calculateAndDisplayRoute(
        directionsService,
        directionsRenderer,
        startPoint,
        endPoint,
        waypoints
      );

      // Build Google Maps URL
      let startPointLabel = `${startLat},${startLng}`;
      let endPointLabel = `${endPoint.lat()},${endPoint.lng()}`;
      let waypointsLabels = this.optimizedPos.map(pos => `${pos.lat},${pos.lng}`);
      
      this.sharedLink = `https://www.google.com/maps/dir/?api=1&origin=${startPointLabel}&destination=${endPointLabel}&travelmode=driving`;
      
      if (waypointsLabels.length > 0) {
        this.sharedLink += `&waypoints=${waypointsLabels.join("|")}`;
      }    
      // Optional: Open in new tab
      // window.open(this.sharedLink, '_blank');
    }
    },
    calculateAndDisplayRoute(
    directionsService,
    directionsRenderer,
    pos_start,
    pos_end,
    waypoints
  ) {

    var request = {
      origin: pos_start,
      destination: pos_end,
      travelMode: window.google.maps.TravelMode.DRIVING,
      optimizeWaypoints: false, // Keep the optimized order from OSRM
      provideRouteAlternatives: false
    };
    
    if (waypoints.length > 0) {
      request.waypoints = waypoints;
    }
    
    directionsService.route(request, (response, status) => {
      if (status == "OK") {
        directionsRenderer.setDirections(response);
        
        // Show route info
        let totalDistance = 0;
        let totalDuration = 0;
        
        response.routes[0].legs.forEach((leg, index) => {
          if (leg.distance) totalDistance += leg.distance.value;
          if (leg.duration) totalDuration += leg.duration.value;
        });
      } else {
        console.error("Directions request failed:", status);
      }
    });
    },

    async init(worksessionId, optimizedPos) {
      this.worksessionId = worksessionId;
      this.optimizedPos = optimizedPos.map((el) => {
        let pushItem = { ...el };
        if (el?.po) {
          pushItem.lat = el.po.latitude;
          pushItem.lng = el.po.longitude;
        }
        return pushItem;
      });
    },
  },
  async updated() {},
  async mounted() {},
};
</script>

<style>
.pos_google_map {
  width: 100%;
  height: 80vh;
}
</style>
